import { z } from 'zod';
/** Общие переменные окружения для серверных приложений. */
export const baseEnvSchema = z.object({
    NODE_ENV: z.enum(['development', 'test', 'production']).default('development'),
    LOG_LEVEL: z.enum(['fatal', 'error', 'warn', 'info', 'debug', 'trace']).default('info'),
    APP_VERSION: z.string().default('dev'),
    DATABASE_URL: z.url(),
    REDIS_URL: z.url(),
    SENTRY_DSN: z
        .url()
        .optional()
        .or(z.literal('').transform(() => undefined)),
});
/** Разбирает env по схеме и падает при старте с понятным списком ошибок. */
export function parseEnv(schema, source) {
    const result = schema.safeParse(source);
    if (!result.success) {
        const lines = result.error.issues.map((i) => `  ${i.path.join('.') || '(root)'}: ${i.message}`);
        throw new Error(`Неверные переменные окружения:\n${lines.join('\n')}`);
    }
    return result.data;
}
//# sourceMappingURL=env.js.map